/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { TagAttachment, TagAttachmentFromJSON, TagAttachmentFromJSONTyped, TagAttachmentToJSON } from "./TagAttachment";

/**
 *
 * @export
 * @interface TagAttachmentControllerResponse
 */
export interface TagAttachmentControllerResponse {
  /**
   *
   * @type {TagImage}
   * @memberof TagAttachmentControllerResponse
   */
  data?: TagAttachment;
  /**
   *
   * @type {ErrorResponse}
   * @memberof TagAttachmentControllerResponse
   */
  error?: ErrorResponse;
}

export function TagAttachmentControllerResponseFromJSON(json: any): TagAttachmentControllerResponse {
  return TagAttachmentControllerResponseFromJSONTyped(json, false);
}

export function TagAttachmentControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TagAttachmentControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : TagAttachmentFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function TagAttachmentControllerResponseToJSON(value?: TagAttachmentControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: TagAttachmentToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
